import { GlobalToken } from 'antd/es/theme/interface'
import { CellValidator, ValidationResult } from '../cell-validators'

const hasManualFloods = (manualFloods: number | undefined | null): boolean => {
    return manualFloods !== undefined && manualFloods !== null
}

const hasStampFloods = (stampFloods: number | undefined | null): boolean => {
    return stampFloods !== undefined && stampFloods !== null
}

const createErrorResult = (token: GlobalToken): ValidationResult => ({
    message: 'Превышено количество ручьев штампа',
    bgColor: token.colorErrorBg,
    color: token.colorErrorText || token.colorError,
})

const createWarningResult = (token: GlobalToken): ValidationResult => ({
    message: 'Указанное количество ручьев меньше количества ручьев штампа',
    bgColor: token.colorWarningBg,
    color: token.colorWarningText || token.colorWarning,
})

const createSuccessResult = (token: GlobalToken): ValidationResult => ({
    message: 'Количество ручьев штампа равно количеству ручьев вручную',
    bgColor: token.colorSuccessBg,
    color: token.colorSuccessText || token.colorSuccess,
})

export const validateFloods: CellValidator = (record, token: GlobalToken) => {
    // Только stampFloods (ручное переопределение при выбранном штампе). Для virtualStamp.floods — не применяем.
    if (record.withoutCutting) {
        return null
    }

    const manualFloods = record.stampFloods
    const stampFloods = record.stamp?.floods

    if (!hasManualFloods(manualFloods) || !hasStampFloods(stampFloods)) {
        return null
    }

    if (manualFloods! > stampFloods!) {
        return createErrorResult(token)
    }

    if (manualFloods! < stampFloods!) {
        return createWarningResult(token)
    }

    return createSuccessResult(token)
}
